import React, { Component } from "react";
import {
  API_TOKEN_NAME,
  USER_ID,
  LOGIN_PHONE_NUMBER,
  PATIENT_NAME,
  SEARCH_SELECTED_DOC_ID,
  SCHEDULE_DATE,
  SCHEDULE_TIME,
} from "../../constants";
import { Route } from "react-router-dom";
import { startUserSession } from "../../userSession";
import { scAxiosAdmin, scAxios } from "../..";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Footer from "../../component/frontend/Footer";
import uhlcare_logo from "../../images/uhlcare-logo.webp";
import uhl_logo from "../../images/UHL (2).webp";
import medix_logo from "../../images/medix-logo.webp";
import ma_rashed_logo from "../../images/ma rashed hospital.webp";
import mainlogo from "../../images/main-logo.webp";

import HomeSearch from "../../component/frontend/commonsections/HomeSearch";
import CenterExcellence from "../../component/frontend/commonsections/CenterExcellence";
import NewsEventsSilde from "../../component/frontend/commonsections/NewsEventsSilde";
import PublicationsSilde from "../../component/frontend/commonsections/PublicationsSilde";
import Moment from "moment";
import HeaderHome from "../frontend/HeaderHome";

const successOrder = () => {
  const name = localStorage.getItem("patient_name");
  return (
    <div>
      <section className="banner-part">
        <Route component={HeaderHome} />
        <div className="container">
          <div
            className="offcanvas offcanvas-start show"
            tabIndex={-1}
            id="offcanvasExample"
            aria-labelledby="offcanvasExampleLabel"
          >
            <div className="offcanvas-header">
              <h5 className="offcanvas-title" id="offcanvasExampleLabel">
                {" "}
              </h5>
              <button
                type="button"
                className="btn-close text-reset"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              />
            </div>
            <div className="offcanvas-body">
              <div className="row text-center" id="logos">
                <div className="col-2 ">
                  <img src={uhlcare_logo} alt="uhlcare-logo" />
                </div>
                <div className="col-2">
                  <img src={mainlogo} alt="medix-logo" />
                </div>
                <div className="col-2">
                  <img src={uhl_logo} alt="uhl-logo" />
                </div>
                <div className="col-2">
                  <img src={medix_logo} alt="medix-logo" />
                </div>

                <div className="col-2">
                  <img src={ma_rashed_logo} alt="medix-logo" />
                </div>
              </div>
              <div className="left-offcanvas">
                <p style={{ "text-align": "center" }}>
                  <i
                    className="fa fa-check-circle mt-10"
                    aria-hidden="true"
                    style={{ color: "#39e75f", "font-size": "80px" }}
                  ></i>
                </p>

                <h4
                  className="mt-3"
                  style={{
                    color: "#39e75f",
                    "text-align": "center",
                    fontSize: "22px",
                  }}
                >
                  Order Successful!
                </h4>
                <div className="payment mt-5">
                  <p>
                    Hi, <strong>{name ? name : ""}</strong>
                  </p>
                  <p>Your Order was received successfully!!</p>
                  {/*<h3 style={{"font-size":"20px", "font-weight":"600"}}>Payment details:</h3>
                        <ul>
                            <li style={{"list-style": "none", "line-height": "40px"}}><strong>Transaction ID: </strong> {this.state.transaction_id}</li>
                            <li style={{"list-style": "none", "line-height": "40px"}}><strong>Appointment ID:</strong> {this.state.appointment_id}</li>
                            <li style={{"list-style": "none", "line-height": "40px"}}><strong>Appointment Date:</strong> {Moment(this.state.appointment_date).format('dddd, LL')}</li>
                            <li style={{"list-style": "none", "line-height": "40px"}}><strong>Appointment Time:</strong> {Moment(this.state.appointment_time, "HH:mm").format("hh:mm A")}</li>
                            <li style={{"list-style": "none", "line-height": "40px"}}><strong>Appointment Doctor Name: </strong> {this.state.doctor_name}</li>
                            <li style={{"list-style": "none", "line-height": "40px"}}><strong>Appointment Doctor Fees: </strong> {this.state.currency} {this.state.doctor_fees}</li>
                            <li style={{"list-style": "none", "line-height": "40px"}}><strong>Appointment Total Amount: </strong> {this.state.currency} {this.state.total_amount}</li>
                            <li style={{"list-style": "none", "line-height": "40px"}}><strong>Payment Status: </strong>{this.state.payment_status} </li>
                        </ul>*/}
                </div>
              </div>
            </div>
          </div>
          <HomeSearch />
        </div>
      </section>
      <CenterExcellence />
      <NewsEventsSilde />
      <PublicationsSilde />
      <Route component={Footer} />
    </div>
  );
};

export default successOrder;



// WEBPACK FOOTER //
// ./src/component/payment/successOrder.js